import React from 'react';
import noop from 'lodash/noop';
import Dialog from 'pages/Dashboard/components/Dialog';
import Medications from 'pages/Dashboard/pages/Charts/pages/Details/components/Medications';
import {
  PatientForm,
} from 'pages/Dashboard/types/patient';

type Props = {
  title: string;
  onClose: () => void;
  patient: PatientForm;
};

export default function ERxDialog({
  title,
  onClose,
  patient,
}: Props) {
  return (
    <Dialog
      open
      title={title}
      onClose={onClose}
      onConfirm={noop}
      confirmText="Create"
      fullWidth
      classes={{
        root: '!w-full !h-screen flex flex-col !p-0 !space-y-0',
        dialog: 'hidden-backdrop populate-iframe-modal !m-0',
        bodyRoot: '!w-screen !m-0 !max-w-[calc(100%-12px)] mx-5 !rounded-xl',
        container: '!justify-start',
        title: 'border-b border-b-gray-300 p-4',
      }}
    >
      <div className="mx-5 h-full">
        <Medications patient={patient} />
      </div>
    </Dialog>
  );
}
